import React, { FC } from 'react'
import Head from 'next/head'

import { localeToCountryCode } from '@app/utils/i18n'

const shouldIndexPage = (value: string) =>
  value === 'index, follow' || value === 'index, nofollow'

type Props = {
  title: string
  description: string
  robots: string
  keywords: string
  pageData: string
  canonical: string
  countryCode: string
  urls: { [key: string]: string }
  availableCountries: string[]
}

export const Seo: FC<Props> = ({
  title,
  description,
  robots,
  keywords,
  pageData,
  canonical,
  countryCode,
  urls = {},
  availableCountries = [],
}) => {
  const canonicalUrl = canonical ? canonical : urls[countryCode]
  const isSelfReferencingCanonical = canonical
    ? canonical.includes(urls[countryCode])
    : true
  const shouldRenderHrefLang =
    isSelfReferencingCanonical &&
    shouldIndexPage(robots) &&
    availableCountries.length > 1
  // this is used by the Storyblok search crawler
  const searchMetadata = pageData ? `,$$${pageData}$$` : ''

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <meta name="keywords" content={`${keywords ?? ''}${searchMetadata}`} />

      <link
        rel="canonical"
        href={`${process.env.NEXT_PUBLIC_BASE_URL}${canonicalUrl}`}
      />

      {shouldRenderHrefLang &&
        availableCountries.map((localeCode) => {
          const countryCode = localeToCountryCode(localeCode)
          return (
            <link
              key={localeCode}
              rel="alternate"
              hrefLang={localeCode}
              href={`${process.env.NEXT_PUBLIC_BASE_URL}${urls[countryCode]}`}
            />
          )
        })}
    </Head>
  )
}
